export interface RequestFormSectionDefinition {
  key: string;
  defaultMessage: string;
}

export const REQUEST_FORM_SECTION_DEFINITIONS: RequestFormSectionDefinition[] = [
  { key: "request-form.organisation", defaultMessage: "Organisation" },
  { key: "request-form.service", defaultMessage: "Service" },
  { key: "request-form.schedule", defaultMessage: "Schedule" },
  { key: "request-form.packingList", defaultMessage: "Packing List" },
  { key: "request-form.provider", defaultMessage: "Provider" },
];

export const QUICK_REQUEST_SECTION_DEFINITIONS: RequestFormSectionDefinition[] = [
  { key: "request-form.organisation", defaultMessage: "Organisation" },
  { key: "request-form.service", defaultMessage: "Service" },
  { key: "request-form.schedule", defaultMessage: "Schedule" },
  { key: "request-form.packingList", defaultMessage: "Packing List" },
  { key: "request-form.attachments", defaultMessage: "Attachments" },
];
